/**
 * Language selector flags (🇫🇮 🇬🇧 🇸🇪) – no snippet edits.
 * Injects flags into header language dropdown for Finnish/English/Swedish.
 */
(function () {
  var FLAG_MAP = {
    fi: '🇫🇮',
    en: '🇬🇧',
    sv: '🇸🇪'
  };

  function baseLang(iso) {
    return (iso || '').split('-')[0].toLowerCase();
  }

  function getFlag(iso) {
    return FLAG_MAP[baseLang(iso)] || '';
  }

  function enhanceLanguageForms() {
    var forms = document.querySelectorAll('.js-localization-form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      var input = form.querySelector('input[name="language_code"]');
      var currentIso = input ? input.value : '';
      var currentFlag = getFlag(currentIso);

      // Button flag
      var btn = form.querySelector('.localization-form__button');
      if (btn && currentFlag && !btn.querySelector('.localization-form__flag')) {
        var span = document.createElement('span');
        span.className = 'localization-form__flag';
        span.textContent = currentFlag;
        span.setAttribute('aria-hidden', 'true');
        btn.insertBefore(span, btn.firstChild);
      }

      // List flags
      var links = form.querySelectorAll('.localization-form__link[data-value]');
      links.forEach(function (link) {
        var iso = link.getAttribute('data-value');
        var flag = getFlag(iso);
        if (!flag) return;

        var text = link.querySelector('.localization-form__item-text');
        if (!text || text.querySelector('.localization-form__flag')) return;

        var f = document.createElement('span');
        f.className = 'localization-form__flag';
        f.textContent = flag;
        f.setAttribute('aria-hidden', 'true');
        text.insertBefore(f, text.firstChild);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceLanguageForms);
  } else {
    enhanceLanguageForms();
  }

  var style = document.createElement('style');
  style.textContent = [
    '@media (max-width: 1199.98px) {',
    '  .localization-form .localization-form__panel { z-index: 30; }',
    '  .localization-form .localization-form__panel.is-active { overflow: visible; height: auto !important; }',
    '  .localization-form .localization-form__panel.is-active .localization-form__link.need-animate {',
    '    visibility: visible; opacity: 1; transform: none; transition: none;',
    '  }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a.js-localization-form-link');
    if (!link) return;
    var href = link.getAttribute('href');
    var form = link.closest('form');
    var input = form && form.querySelector('input[name="language_code"]');
    var code = link.getAttribute('data-value');
    if (!form || !input || !code || !href || href === '#' || input.value === code) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = code;
    var data = new FormData(form);
    data.set('language_code', code);
    var returnTo = data.get('return_to');
    if (typeof returnTo === 'string') {
      data.set('return_to', returnTo.replace(/^\/(en|sv)(?=\/|$)/, '') || '/');
    }
    fetch(form.getAttribute('action') || '/localization', {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      redirect: 'follow'
    }).finally(function () {
      window.location.assign(href);
    });
  }, true);
})();

